export default __webpack_public_path__ + "static/media/5dda97941b231c2b537d65bdd1de23c01639412646133.03c1989c.webp";